<ds-results-back-button *ngIf="showBackButton$ | async" [back]="back"></ds-results-back-button>
<div class="d-flex flex-row">
  <ds-item-page-title-field class="mr-auto" [item]="object">
  </ds-item-page-title-field>
  <ds-dso-edit-menu></ds-dso-edit-menu>
</div>
<div class="row columnset-row">
  <div class="col-xs-12 col-md-4 left-column">
    <ds-generic-item-page-field [item]="object"
      [fields]="['person.identifier.orcid']"
      [label]="'person.page.orcid'">
    </ds-generic-item-page-field>
  </div>
  <div class="col-xs-12 col-md-7 center-column">
    <ds-related-items
      [parentItem]="object"
      [relationType]="'isPublicationOfAuthor'"
      [label]="'relationships.isPublicationOf' | translate"
      [incrementBy]="100">
    </ds-related-items>
    <div>
      <a class="btn btn-outline-primary" [routerLink]="[itemPageRoute + '/full']" role="link" tabindex="0">
        {{"item.page.link.full" | translate}}
      </a>
    </div>
  </div>
</div>
